import { Terminal } from "@/States/Terminals";
import { isValidCoordinatesValue } from "@/Utils/isValidCoordinatesValue";
import { isValidEmail } from "@/Utils/isValidEmail";
import { isValidPhoneNumberAllowEmpty } from "@/Utils/isValidPhoneNumber";
import { RealEstateCategory } from "@/api/types";

import { isValidTimestamp } from "../isValidTimestamp";

// returns a locize key to the error to be shown
type ValidationFunction = (value: any) => string | undefined;

export const terminalNameValidation = ({
  value,
  terminals,
}: {
  value: string;
  terminals?: Terminal[];
}) => {
  const duplicateName = terminals?.find((t) => t.name === value);
  if (duplicateName) return "errors:duplicateValue";
};

export const buildingCategoryValidation = ({ value }: { value: any }) => {
  if (!Object.values(RealEstateCategory).includes(value)) {
    return "errors:invalidValue";
  }
};

export const contactEmailValidation = ({ value }: { value: string }) => {
  if (!isValidEmail(value)) {
    return "errors:wrongEmailFormat";
  }
};

export const phoneNumberValidation = ({ value }: { value: any }) => {
  if (!isValidPhoneNumberAllowEmpty(value?.toString())) {
    return "errors:wrongPhoneNumberFormat";
  }
};

export const numberValidation = ({ value }: { value: any }) => {
  if (value && isNaN(Number(value))) {
    return "errors:invalidValue";
  }
};

export const timestampValidation = ({ value }: { value: string }) => {
  if (!isValidTimestamp(value)) {
    return "errors:wrongTimestampFormat";
  }

  const now = new Date();
  const timestamp = new Date(value);

  if (timestamp > now) {
    return "errors:timestampInFuture";
  }
};

export const linkedValueValidation = ({
  value,
  linkingValues = [],
}: {
  value: string;
  linkingValues: string[];
}) => {
  if (value && !linkingValues.includes(value)) {
    return "errors:unrecognizedValue";
  }
};

type ValueInArrayProps = {
  value: string;
  arrayOfValues: {
    id: string;
    name?: string;
  }[];
  errorKey?: string;
};

export const valueInArrayValidation = ({
  value,
  arrayOfValues,
  errorKey = "invalidValue",
}: ValueInArrayProps) => {
  if (value && !arrayOfValues?.find((w) => w.id === value)) {
    return `errors:${errorKey}`;
  }
};

export const carrotAccessParentIDValidation = (props: ValueInArrayProps) =>
  valueInArrayValidation({ ...props, errorKey: "unrecognizedAccessParentID" });

export const coordinatesValidation = ({ value }: { value: any }) => {
  if (value && !isValidCoordinatesValue(value.toString())) {
    return "errors:mustBeValidCoordinates";
  }
};

export const requiredFieldValidation = ({ value }: { value: string }) => {
  if (!value) return "errors:requiredFields";
};

export const anythingAllowed = () => undefined;

export const validate = (
  validationFunctions: ValidationFunction[],
  funcProps: any,
) => {
  const results = validationFunctions.map((func) => func(funcProps));

  const errorResults = results.filter(Boolean);

  return errorResults[0];
};
